import * as React from 'react';
import { connect, Dispatch } from 'react-redux';

import Maintenance from '../components/Maintenance';
import { StoreState } from '../types';

export default connect(mapStateToProps, mapDispatchToProps)(
  class MaintenanceContainer extends React.Component<
    MaintenanceContainerProps,
    MaintenanceContainerState
  > {
    constructor(props: MaintenanceContainerProps) {
      super(props);
    }

    render() {
      return <Maintenance />;
    }
  }
);

export interface MaintenanceContainerProps {}

export interface MaintenanceContainerState {}

function mapStateToProps(state: StoreState) {
  return {};
}

function mapDispatchToProps(dispatch: Dispatch<StoreState>) {
  return {};
}



// WEBPACK FOOTER //
// ./src/containers/Maintenance.tsx